import { getKeywords } from "../../api/getKeywords";
import { commonErrorToastMessage } from "../../components/toastify/AllToastifyErrors";

/**
 * Navigates to the keywords page with necessary data if input validation passes.
 *
 * @param {string} title - The title input.
 * @param {string} domain - The selected domain.
 * @param {number} wordCount - The word count.
 * @param {string} doc_id - The document ID.
 * @param {string} content - The document content.
 * @param {Object} responseData - Response data object.
 * @param {RefObject} titleInputRef - Ref for the title input element.
 * @param {RefObject} domainSelectRef - Ref for the domain select element.
 * @param {function} setIsLoading - Function to set loading state.
 * @param {function} setIsTextLoading - Function to set text loading state.
 * @param {function} navigate - Function for navigation.
 * @param {File} selectedFile - The selected file.
 */
export const navigateToKeywords = async (
  title,
  domain,
  wordCount,
  doc_id,
  content,
  responseData,
  titleInputRef,
  domainSelectRef,
  setIsLoading,
  setIsTextLoading,
  navigate,
  selectedFile,
  user
) => {
  // Check if title is empty
  if (!title) {
    commonErrorToastMessage("Please add title for your content.");
    titleInputRef?.current?.focus();
    return;
  }

  // Check if domain is empty
  if(!user.isGPT){
    if (!domain) {
      commonErrorToastMessage(
        "Please choose the domain to which your content belongs."
      );
      domainSelectRef?.current.focus();
      return;
    }
  }

  // Check if word count is less than 300
  if (wordCount < 300 || wordCount > 3000) {
    commonErrorToastMessage(
      "Word count must be between 300-3000 for question generation."
    );
    return;
  }

  try {
    // Set loading states
    setIsLoading(true);
    setIsTextLoading(true);

    // Fetch keywords from PDF
    const keywordsResponseFromPDF = await getKeywords(doc_id ,title ,content ,wordCount);

    // Reset loading states
    setIsTextLoading(false);
    setIsLoading(false);

    localStorage.setItem("content", content);
    localStorage.setItem("title", title);
    localStorage.setItem("doc_id", responseData.doc_id);
    localStorage.setItem("domain", domain);
    localStorage.setItem("total_words",wordCount)
    localStorage.setItem(
      "keywordsResponse",
      JSON.stringify(keywordsResponseFromPDF)
    );

    // Navigate to the keywords page
    navigate(`/keywords`);
  } catch (error) {
    // Handle API request error
    console.error("Error while making the API request:", error.message);
    setIsLoading(false);
    setIsTextLoading(false);

    commonErrorToastMessage("Error while generating keywords.");
  } finally {
    // Reset loading state if no selected file
    if (!selectedFile) {
      setIsLoading(false);
      setIsTextLoading(false);
    }
  }
};

// import { getKeywords } from "../../api/getKeywords";
// import { getdisseqtKeywords } from "../../api/disseqtkeyword";
// import { commonErrorToastMessage } from "../../components/toastify/AllToastifyErrors";

// function processGuardrailKeywords(disseqtResponse, guardrailParams) {
//   const isAdmin = guardrailParams.is_admin === true || "true";
  
//   // Extract OpenAI guardrails results (all users get this)
//   const openaiCategories = disseqtResponse?.data?.openai_gurdrails_results?.categories || [];
//   const openaiKeywords = openaiCategories.map((item) => item.category);

//   let allKeywords = [];
//   let processedData = {
//     openai_keywords: openaiKeywords,
//     openai_categories: openaiCategories,
//   };

//   if (isAdmin) {
//     // For admin users: include disseqt validators as keywords
//     const disseqtValidators = disseqtResponse?.data?.disseqt_gurdrails_results || {};
    
//     const promptInjectionValidator = disseqtValidators.InputPromptInjectionValidator;
//     const promptInjectionKeyword = promptInjectionValidator?.validator_name || "prompt-injection";
//     const promptInjectionPassed = promptInjectionValidator?.threshold_validated_result === "Pass";

//     const invisibleTextValidator = disseqtValidators.InvisibleTextValidator;
//     const invisibleTextKeyword = invisibleTextValidator?.validator_name || "invisible-text";
//     const invisibleTextPassed = invisibleTextValidator?.threshold_validated_result === "Pass";

//     // Combine all keywords: OpenAI categories + disseqt validators
//     allKeywords = [
//       ...openaiKeywords,
//       promptInjectionKeyword,
//       invisibleTextKeyword,
//     ];

//     processedData = {
//       ...processedData,
//       disseqt_validators: [
//         {
//           name: promptInjectionKeyword,
//           passed: promptInjectionPassed,
//           validator: promptInjectionValidator,
//         },
//         {
//           name: invisibleTextKeyword,
//           passed: invisibleTextPassed,
//           validator: invisibleTextValidator,
//         },
//       ],
//       isAdmin: true,
//     };
//   } else {
//     // For non-admin users: only OpenAI guardrails
//     allKeywords = openaiKeywords;
//   }

//   return {
//     data: {
//       keywords: allKeywords,
//       ...processedData,
//       disseqtRaw: disseqtResponse?.data || {},
//       isDisseqt: true,
//     },
//   };
// }

// /**
//  * Navigates to the keywords page with necessary data if input validation passes.
//  *
//  * @param {string} title - The title input.
//  * @param {string} domain - The selected domain.
//  * @param {number} wordCount - The word count.
//  * @param {string} doc_id - The document ID.
//  * @param {string} content - The document content.
//  * @param {Object} responseData - Response data object.
//  * @param {RefObject} titleInputRef - Ref for the title input element.
//  * @param {RefObject} domainSelectRef - Ref for the domain select element.
//  * @param {function} setIsLoading - Function to set loading state.
//  * @param {function} setIsTextLoading - Function to set text loading state.
//  * @param {function} navigate - Function for navigation.
//  * @param {File} selectedFile - The selected file.
//  */
// export const navigateToKeywords = async (
//   title,
//   domain,
//   wordCount,
//   doc_id,
//   content,
//   responseData,
//   titleInputRef,
//   domainSelectRef,
//   setIsLoading,
//   setIsTextLoading,
//   navigate,
//   selectedFile,
//   user
// ) => {
//   // Check if title is empty
//   if (!title) {
//     commonErrorToastMessage("Please add title for your content.");
//     titleInputRef?.current?.focus();
//     return;
//   }

//   // Check if domain is empty
//   if(!user.isGPT){
//     if (!domain) {
//       commonErrorToastMessage(
//         "Please choose the domain to which your content belongs."
//       );
//       domainSelectRef?.current.focus();
//       return;
//     }
//   }

//   // Check if word count is less than 300
//   if (wordCount < 300 || wordCount > 3000) {
//     commonErrorToastMessage(
//       "Word count must be between 300-3000 for question generation."
//     );
//     return;
//   }

//   try {
//     // Set loading states
//     setIsLoading(true);
//     setIsTextLoading(true);

//     const email = localStorage.getItem("email");
//     const guardrailUsers = [
//       "Abhishek.Nighojkar@harbingergroup.com",
//       "Umeshk@harbingergroup.com",
//     ];

//     const isAdminUser = guardrailUsers.includes(email);

//     // ✅ CHANGED: Use getdisseqtKeywords instead of getKeywords
//     const guardrailParams = {
//       Usergpt_key: "LIMITED",
//       email: email,
//       user_type: "gpt_user",
//       is_admin: isAdminUser ? true : false,
//     };


//     // // Fetch keywords from PDF
//     // const keywordsResponseFromPDF = await getKeywords(doc_id ,title ,content ,wordCount);
//     const disseqtResponse = await getdisseqtKeywords(
//       doc_id,
//       title,
//       content,
//       wordCount,
//       guardrailParams,
//     );

//     console.log("disseqtResponse from navigateToKeywords:", disseqtResponse);

//     // ✅ Process guardrail keywords properly
//     const keywordsResponseFromPDF = processGuardrailKeywords(disseqtResponse, guardrailParams);


//     // Reset loading states
//     setIsTextLoading(false);
//     setIsLoading(false);

//     localStorage.setItem("content", content);
//     localStorage.setItem("title", title);
//     localStorage.setItem("doc_id", responseData.doc_id);
//     localStorage.setItem("domain", domain);
//     localStorage.setItem("total_words",wordCount)
//     localStorage.setItem(
//       "keywordsResponse",
//       JSON.stringify(keywordsResponseFromPDF)
//     );
    
//     // Store guardrail results separately
//     localStorage.setItem(
//       "guardrailResults",
//       JSON.stringify({
//         openai_gurdrails_results:
//           disseqtResponse?.data?.openai_gurdrails_results ?? null,
//         disseqt_gurdrails_results:
//           disseqtResponse?.data?.disseqt_gurdrails_results ?? null,
//         isAdmin: isAdminUser,
//       })
//     );

//     // Navigate to the keywords page
//     navigate(`/keywords`);
//   } catch (error) {
//     // Handle API request error
//     console.error("Error while making the API request:", error.message);
//     setIsLoading(false);
//     setIsTextLoading(false);

//     commonErrorToastMessage("Error while generating keywords.");
//   } finally {
//     // Reset loading state if no selected file
//     if (!selectedFile) {
//       setIsLoading(false);
//       setIsTextLoading(false);
//     }
//   }
// };
